"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _reactI18next = require("react-i18next");

var _LoginForm = _interopRequireDefault(require("../LoginForm"));

var _ForgottenPassForm = _interopRequireDefault(require("../ForgottenPassForm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var LoginAndForgottenPassForm = function LoginAndForgottenPassForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      forgottenPass = _useState2[0],
      setForgottenPass = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      password = _useState6[0],
      setPassword = _useState6[1];

  var toggleForgottenPass = function toggleForgottenPass() {
    return setForgottenPass(!forgottenPass);
  };

  var onFormChange = function onFormChange(key, value) {
    if (key === 'email') setEmail(value);
    if (key === 'password') setPassword(value);
  };

  var commonProps = {
    customErrors: props.customErrors,
    createValidator: props.createValidator,
    onChange: onFormChange,
    model: {
      email: email,
      password: password
    }
  };
  return _react.default.createElement("div", null, forgottenPass ? _react.default.createElement(_ForgottenPassForm.default, _extends({
    header: props.forgottenPassHeader,
    onSubmit: props.onForgottenPassSubmit
  }, commonProps)) : _react.default.createElement(_LoginForm.default, _extends({
    header: props.loginFormHeader,
    onSubmit: props.onLoginSubmit
  }, commonProps)), _react.default.createElement(_core.Button, {
    fullWidth: true,
    onClick: toggleForgottenPass
  }, forgottenPass ? props.customButtonLabels && props.customButtonLabels.back || t('Back to login form') : props.customButtonLabels && props.customButtonLabels.forgot || t('I forgot my password')));
};

LoginAndForgottenPassForm.propTypes = {
  header: _propTypes.default.string,
  customErrors: _propTypes.default.object,
  loginFormHeader: _propTypes.default.string,
  forgottenPassHeader: _propTypes.default.string,
  customButtonLabels: _propTypes.default.exact({
    back: _propTypes.default.string,
    forgot: _propTypes.default.string
  }),
  onLoginSubmit: _propTypes.default.func.isRequired,
  onForgottenPassSubmit: _propTypes.default.func.isRequired,
  createValidator: _propTypes.default.func.isRequired
};
var _default = LoginAndForgottenPassForm;
exports.default = _default;